import $ from 'jquery';
jQuery.noConflict();

// When shipping section is completed, grab updated data and recompile handlebars totals template
    export function shippingSaveReloadSidebar() {
        if ($("#co-shipping-method-form").length) {
            var url = $("#co-shipping-method-form").attr("data-remote");
            // $('.loading-overlay').show();

            setTimeout(function () {
                $.ajax({
                    url: url,
                    type: "GET",
                    dataType: "json",
                    cache: false,
                }).done(function (data) {
                    // Reloading Cart Sidebar Count and Total for Mobile Cart
                    var mobileTemplate = require("../../templates/mobileCart.handlebars");
                    var mobileHtml = mobileTemplate(data);
                    $("#mobile-cart").html(mobileHtml);
                    // $('.loading-overlay').hide();
                });
            }, 2000);
        };
    };


    // When payment section is completed, reload totals in case there's store credit
    export function paymentSaveReloadSidebar() {
        if ($("#co-payment-form").length) {
            var url = $("#co-payment-form").attr("data-remote");
            // $('.loading-overlay').show();

            setTimeout(function () {
                $.ajax({
                    url: url,
                    type: "GET",
                    dataType: "json",
                    cache: false,
                }).done(function (data) {
                    // Reloading Cart Sidebar Count and Total for Mobile Cart
                    var mobileTemplate = require("../../templates/mobileCart.handlebars");
                    var mobileHtml = mobileTemplate(data);
                    $("#mobile-cart").html(mobileHtml);
                    // $('.loading-overlay').hide();
                });
            }, 2000);
        };
    }

    export function refreshCartSidebar() {
        var productsUrl = $('#cart-sidebar-products').attr('data-remote');
        var $wrapper = jQuery('#checkout-progress-wrapper');

        $.ajax({
            url: productsUrl + "?limit=100",
            dataType: "json",
            beforeSend: function () {
                $('.loading-overlay').show();
                $wrapper.addClass('is-loading');
            },
        }).done(function (data) {
            //Getting Cart Sidebar Products Using Handlebars
            var productsTemplate = require("../../templates/products.handlebars");
            var productsHtml = productsTemplate(data);
            $("#cart-sidebar-products").html(productsHtml);
            $('.liner').show();
            $('.loading-overlay').hide();
            $wrapper.removeClass('is-loading');
        });

        return;
    }

    export function refreshSidebarTotalsOnly() {
        const productUrl = jQuery('#cart-sidebar-products').attr('data-remote');
        if (!productUrl) return;

        var $wrapper = jQuery('#checkout-progress-wrapper');
        var $wrap = jQuery('#sidebar-totals-wrap');
        var $overlay = $wrap.find('.loading-overlay');

        jQuery.ajax({
            url: productUrl,
            type: 'GET',
            dataType: 'json',
            beforeSend: function () {
                $wrapper.addClass('is-loading'); 
                $overlay.show();
            }
        }).done(function (data) {
            if (data && data.totalsHtml) {
                jQuery('#sidebar-order-totals').html(data.totalsHtml);
            }
        }).always(function () {
            $overlay.hide();
            $wrapper.removeClass('is-loading');
        });
    }

    export function bindSidebarTotalsFromResponse() {
        if (typeof Ajax === 'undefined' || !Ajax.Responders) return;

        Ajax.Responders.register({
            onComplete: function(request, transport) {
                try {
                    var url = request.url || '';
                    // saveShipping is a prefix of saveShippingMethod — check method first.
                    var isSaveShippingMethod = url.indexOf('/checkout/onepage/saveShippingMethod') !== -1;
                    var isSaveShipping = !isSaveShippingMethod && url.indexOf('/checkout/onepage/saveShipping') !== -1;
                    var isSavePayment = url.indexOf('/checkout/onepage/savePayment') !== -1;

                    if (!(isSaveShippingMethod || isSaveShipping || isSavePayment)) {
                        return;
                    }

                    var response = JSON.parse(transport.responseText);
                    if (response && (response.totalsHtml || response.totals_html)) {
                        jQuery('#sidebar-order-totals').html(response.totalsHtml || response.totals_html);
                    }

                    // Re-pull miniCart after shipping steps so totals/drawer stay current.
                    // saveShippingMethod also persists shipping insurance — use the
                    // warranty-style full paint so the cart drawer picks up the fee item.
                    if (response && !response.error) {
                        if (isSaveShippingMethod) {
                            setTimeout(function () {
                                refreshCartAfterShippingMethod();
                            }, 300);
                        } else if (isSaveShipping) {
                            setTimeout(function () {
                                refreshSidebarTotalsOnly();
                            }, 300);
                        }
                    }
                } catch (e) {}
            }
        });
    }

    export function bindAfterShippingMethodRefreshCart() {
        // Intentionally empty: saveShippingMethod refresh is handled once by
        // bindSidebarTotalsFromResponse → refreshCartAfterShippingMethod() (full miniCart).
        // A second window.refreshMiniCart() here would duplicate that AJAX call.
    }

    /**
     * After saveShippingMethod (insurance is persisted here), re-pull miniCart and
     * paint the same surfaces the warranty add flow does: order totals, checkout
     * sidebar products, cart drawer count/subtotal, header mini-cart items list,
     * and modal cart list. Two AJAX calls mirror the warranty pattern exactly so
     * #modal-cart-data is always updated independently of #cart-sidebar-products.
     */
    export function refreshCartAfterShippingMethod() {
        var productUrl = jQuery('#cart-sidebar-products').attr('data-remote');
        if (!productUrl) return;

        var $wrapper = jQuery('#checkout-progress-wrapper');
        var $wrap = jQuery('#sidebar-totals-wrap');
        var $overlay = $wrap.find('.loading-overlay');
        var join = productUrl.indexOf('?') > -1 ? '&' : '?';
        var url100 = productUrl + join + 'limit=100';

        // AJAX 1 – mirrors warranty AJAX 1: sidebar products, totals, counts, header cart items
        jQuery.ajax({
            url: url100,
            type: 'GET',
            dataType: 'json',
            beforeSend: function () {
                $wrapper.addClass('is-loading');
                $overlay.show();
            }
        }).done(function (data) {
            var $miniCart = jQuery('.header .cart.sidebar');

            // Item count badge
            var qty = parseInt(data.items_qty, 10);
            if (isNaN(qty)) qty = 0;
            $miniCart.find('.minicart-item-count')
                .text(qty)
                .toggleClass('minicart-item-count--empty', qty < 1);

            // Header mini-cart subtotal
            $miniCart.find('.subtotal .price').html('$' + data.subtotal);

            // Checkout totals table + sidebar order totals
            if (jQuery('#shopping-cart-totals-table').length && data.totalsHtml) {
                jQuery('#shopping-cart-totals-table').replaceWith(data.totalsHtml);
            }
            if (jQuery('#sidebar-order-totals').length && data.totalsHtml) {
                jQuery('#sidebar-order-totals').html(data.totalsHtml);
            }

            // Checkout sidebar products panel
            var productsTemplate = require('../../templates/products.handlebars');
            jQuery('#cart-sidebar-products').html(productsTemplate(data));

            // Sidebar item count toggle
            if (typeof data.items_qty !== 'undefined') {
                jQuery('.sidebar-items-toggle__count').text(data.items_qty);
            }

            // Cart drawer count text
            var countText = data.items_qty == 1 ? '1 item' : data.items_qty + ' items';
            jQuery('.block-cart .cart-drawer .cart-count .amount').text(countText);

            // Mobile cart
            var mobileTemplate = require('../../templates/mobileCart.handlebars');
            jQuery('#mobile-cart').html(mobileTemplate(data));

            // Header cart sidebar li items (ol#cart-sidebar inside .header .cart.sidebar)
            if (typeof data.items !== 'undefined' && data.items.length) {
                var $miniCartItems = $miniCart.find('#cart-sidebar');
                $miniCartItems.find('li').remove();
                for (var i = 0; i < data.items.length; i++) {
                    try {
                        var item = data.items[i];
                        var $li = '<li class="item">' +
                            '<span class="product-image">' +
                            '<img src="' + item.image_thumbnail + '" width="50" height="50" alt="' + item.name + '">' +
                            '</span>' +
                            '<div class="product-details">' +
                            '<p class="product-name"><a href="' + (item.url || '') + '">' + item.name + '</a></p>' +
                            '<strong>' + item.qty + '</strong> x' +
                            '<span class="price">$' + item.price + '</span>' +
                            '</div>' +
                            '</li>';
                        $miniCartItems.append($li);
                    } catch (err) {
                        console.log(err);
                    }
                }
            }
        }).always(function () {
            $overlay.hide();
            $wrapper.removeClass('is-loading');
        });

        // AJAX 2 – mirrors warranty AJAX 2: modal cart list, independent of AJAX 1
        jQuery.ajax({
            url: url100,
            type: 'GET',
            dataType: 'json'
        }).done(function (data) {
            var productsModalTemplate = require('../../templates/productsModal.handlebars');
            jQuery('#modal-cart-data').html(productsModalTemplate(data));
        });
    }

    /**
     * Refresh checkout review step from cart data (totals + sidebar).
     * Accepts either:
     * - miniCart response: { totalsHtml, items, items_qty, subtotal, ... }
     * - classic-fees add response: { totals_html, cart_sidebar }
     * Use after warranty add or classic-fees/cart/add so both flows share one refresh.
     *
     * @param {Object} data - Cart/totals payload
     * @returns {boolean} - true if sidebar was updated from data; false if no cart data (caller may refreshCartSidebar())
     */
    export function refreshCheckoutReviewFromCartData(data) {
        if (!data) return false;

        var reviewItemsHtml = data.review_items_html;
        if (reviewItemsHtml && $('#checkout-review-table').length) {
            $('#checkout-review-table').html(reviewItemsHtml);
            if (typeof window.handleProductWarranty === 'function') {
                window.handleProductWarranty();
            }
        }

        var totalsHtml = data.totalsHtml || data.totals_html;
        if (totalsHtml) {
            if ($('#shopping-cart-totals-table').length) {
                $('#shopping-cart-totals-table').replaceWith(totalsHtml);
            }
            if ($('.review-totals-wrapper').length) {
                $('.review-totals-wrapper').html(totalsHtml);
            }
            if ($('#sidebar-order-totals').length) {
                $('#sidebar-order-totals').html(totalsHtml);
            }
        }

        var cartPayload = data.cart_sidebar || data;
        if (cartPayload && cartPayload.error) return false;

        if (cartPayload && ($('#cart-sidebar-products').length || $('#sidebar-order-totals').length)) {
            var sidebarUpdated = updateCartSidebarFromData(cartPayload);
            if (sidebarUpdated && cartPayload.subtotal != null) {
                var $miniCart = $('.header .cart.sidebar');
                if ($miniCart.length) {
                    $miniCart.find('.subtotal .price').html('$' + cartPayload.subtotal);
                }
            }
            if (sidebarUpdated && typeof cartPayload.items !== 'undefined' && $('#modal-cart-data').length) {
                try {
                    var productsModalTemplate = require("../../templates/productsModal.handlebars");
                    $("#modal-cart-data").html(productsModalTemplate(cartPayload));
                } catch (e) {}
            }
            return sidebarUpdated;
        }

        return false;
    }

    // Update cart sidebar from provided data (avoids AJAX call)
    export function updateCartSidebarFromData(cartData) {
        try {
            if (!cartData) {
                console.log('Cart sidebar data is null/undefined');
                return false;
            }
            
            if (cartData.error) {
                console.log('Cart sidebar data has error:', cartData.error);
                return false;
            }

            // Use the same Handlebars template as refreshCartSidebar
            var productsTemplate = require("../../templates/products.handlebars");
            var productsHtml = productsTemplate(cartData);
            var $cartSidebarProducts = $("#cart-sidebar-products");
            
            if ($cartSidebarProducts.length) {
                $cartSidebarProducts.html(productsHtml);

                if (typeof cartData.items_qty !== 'undefined') {
                    $('.sidebar-items-toggle__count').text(cartData.items_qty);

                    var countText = cartData.items_qty == 1 ? '1 item' : cartData.items_qty + ' items';
                    $('.block-cart .cart-drawer .cart-count .amount').text(countText);
                    $('.minicart-item-count').text(cartData.items_qty);
                }

                if ($('#mobile-cart').length) {
                    var mobileTemplate = require("../../templates/mobileCart.handlebars");
                    var mobileHtml = mobileTemplate(cartData);
                    $("#mobile-cart").html(mobileHtml);
                }

                $('.liner').show();
                $('.loading-overlay').hide();
                return true;
            } else {
                console.log('Cart sidebar products element not found');
                return false;
            }
        } catch (e) {
            console.error('Error updating cart sidebar from data:', e);
            return false;
        }
    }
